import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'left',
        color: '#fff',
        backgroundColor: '#0D0713',
        minHeight: '100vh',
        fontFamily: 'Libre Franklin, sans-serif',
      }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1>Privacy Policy for Which Year (whichyr.com)</h1>
        <p style={{ marginBottom: '1em' }}>
          <strong>Last Updated: May 29, 2025</strong>
        </p>

        <p style={{ marginBottom: '1em' }}>
          Welcome to Which Year! This Privacy Policy explains how we collect,
          use, and protect your information when you visit our website
          whichyr.com (the "Site") and play our game.
        </p>

        <h2>Information We Collect</h2>
        <p style={{ marginBottom: '1em' }}>
          We may collect the following types of information:
        </p>
        <ul style={{ marginBottom: '1em' }}>
          <li style={{ marginBottom: '0.5em' }}>
            <strong>Usage Data:</strong> Information about your interactions
            with the game, such as scores, game progress (e.g., daily challenge
            completion, rounds played, hints used), and statistics (e.g.,
            average score, high score). This data is stored locally in your
            browser's localStorage and is not typically transmitted to our
            servers unless you complete a daily challenge, in which case
            anonymized score data may be submitted for global
            leaderboard/distribution statistics.
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            <strong>Technical Data:</strong> Like most websites, we may collect
            data that your browser sends like the browser type, browser version,
            the pages of our Site that you visit, the time and date of your
            visit, the time spent on those pages, and other diagnostic data.
            This is often collected via standard server logs or analytics tools.
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            <strong>Google Analytics:</strong> We use Google Analytics to help
            us understand how our users engage with the Site. Google Analytics
            may use cookies to collect information about your use of the Site.
            This information is used to compile reports and to help us improve
            the Site. You can learn more about Google's practices by going to{' '}
            <a
              href="https://www.google.com/policies/privacy/partners/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#C6A4FF' }}
            >
              https://www.google.com/policies/privacy/partners/
            </a>
            , and opt-out by downloading the Google Analytics opt-out browser
            add-on, available at{' '}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#C6A4FF' }}
            >
              https://tools.google.com/dlpage/gaoptout
            </a>
            .
          </li>
        </ul>

        <h2>How We Use Your Information</h2>
        <p style={{ marginBottom: '1em' }}>
          We use the information we collect to:
        </p>
        <ul style={{ marginBottom: '1em' }}>
          <li style={{ marginBottom: '0.5em' }}>
            Provide, operate, and maintain our game.
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            Save your game progress and statistics locally on your device.
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            Understand and analyze how you use our game to improve user
            experience.
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            (If applicable for daily challenges) Display aggregated, anonymized
            score distributions.
          </li>
        </ul>

        <h2>LocalStorage</h2>
        <p style={{ marginBottom: '1em' }}>
          Our game utilizes your browser's localStorage to save your game
          progress, settings, and statistics. This data remains on your computer
          and is not automatically transmitted to us, except for score data for
          daily challenges as described above. You can clear your browser's
          localStorage to remove this data, but doing so will reset your game
          progress and statistics.
        </p>

        <h2>Third-Party Services</h2>
        <p style={{ marginBottom: '1em' }}>
          We may use third-party services such as Google Analytics. These
          services have their own privacy policies addressing how they use such
          information.
        </p>

        <h2>Children's Privacy</h2>
        <p style={{ marginBottom: '1em' }}>
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from children
          under 13.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p style={{ marginBottom: '1em' }}>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page and
          updating the "Last Updated" date.
        </p>

        <h2>Contact Us</h2>
        <p style={{ marginBottom: '1em' }}>
          If you have any questions about this Privacy Policy, you can contact
          us at: whichyrgame@gmail.com
        </p>
      </div>
    </div>
  );
};
export default PrivacyPolicyPage;
